const mapLinks = () => {

	/**
	* Apple Maps preference for directions links
	*
	* Usage:
	*   <a class="map-link" data-map-address="9485 Lebanon Rd, Mt Juliet, TN 37122"
	*      href="https://www.google.com/maps/dir/?api=1&destination=...">…</a>
	*
	* The markup ships a Google Maps directions URL, because that one resolves
	* on every platform and keeps working with JS disabled or before this runs.
	* On Apple devices the href is swapped for the Apple Maps equivalent, which
	* hands off to the native app instead of the browser. Everyone else is left
	* on the Google URL that was already there — that's the fallback.
	*
	* Data attributes:
	*   data-map-address  (required) Plain-text address to route to
	*/

	const links = document.querySelectorAll('a.map-link[data-map-address]');
	if (!links.length) return;

	// iPadOS 13+ reports itself as "Macintosh", so the touch check is what
	// separates an iPad from a desktop Mac. Both are Apple, so either way the
	// answer here is the same — it just keeps the test honest.
	const ua = navigator.userAgent || '';
	const isApple = /iPad|iPhone|iPod/.test(ua)
		|| /Macintosh/.test(ua)
		|| (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

	if (!isApple) return;

	links.forEach((link) => {
		const address = link.getAttribute('data-map-address');
		if (!address) return;

		link.setAttribute('href', `https://maps.apple.com/?daddr=${encodeURIComponent(address)}`);
	});

};

export { mapLinks };
